"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CheckmarkMedium;

var _CheckmarkMedium = require("@adobe/react-spectrum-ui/dist/CheckmarkMedium");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CheckmarkMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CheckmarkMedium.CheckmarkMedium, null));
}